import * as statusassinatura from '@/api/statusassinatura'

const state = {
  modalPromotora: false,
  totalizadores: [],
  liberado: {
    valor: 0,
    quantidade: 0
  }
}

const mutations = {
  MODALPROMOTORA (state) {
    state.modalPromotora = !state.modalPromotora
  },
  SETTOTALIZADORES (state, payload) {
    state.totalizadores = payload
  },
  SETLIBERADO (state, payload) {
    state.liberado = {
      valor: payload.valor_total,
      quantidade: payload.quantidade
    }
  }
}

const actions = {
  modalPromotora: function ({ commit }) {
    commit('MODALPROMOTORA')
  },
  getAssinaturas: async function ({ commit }, payload) {
    payload.mostrar_todos = false
    let data = await statusassinatura.getAssinaturas(payload)
    return data.instancia
  },
  getTodasAssinaturas: async function ({ commit }, payload) {
    payload.mostrar_todos = true
    let data = await statusassinatura.getAssinaturas(payload)
    return data.instancia
  },
  getTotalizadores: async function ({ commit }, payload) {
    let data = await statusassinatura.getTotalizadores(payload)
    commit('SETTOTALIZADORES', data.instancia)
  },
  getLiberado: async function ({ commit }, payload) {
    let data = await statusassinatura.getLiberado(payload)
    commit('SETLIBERADO', data.instancia)
  }
}

export default { namespaced: true, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/adm_financeiro/statusassinaturas.js